// MedicalCenterSelectorModal.jsx
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useState } from "react";

export default function MedicalCenterSelectorModal({
  medicalCenters,
  visible,
  onHide,
  onExport,
}) {
  const [selectedCenters, setSelectedCenters] = useState([]);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    setIsExporting(true);
    try {
      await Promise.resolve(onExport(selectedCenters));
    } catch (error) {
      console.error("Error en la exportación:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Dialog
      header="Seleccionar proveedor(es)"
      visible={visible}
      onHide={onHide}
      style={{ width: "50vw" }}
      draggable={false}
      className="p-4 rounded-lg shadow-lg"
    >
      <div className="flex flex-column gap-3">
        {/* Lista de proveedores con checkboxes */}
        <div className="surface-card p-3 border-round shadow-1">
          {medicalCenters?.map((center) => (
            <div
              key={center.id}
              className="flex align-items-center gap-3 py-2 border-bottom-1 surface-border"
            >
              <input
                type="checkbox"
                id={`center-${center.id}`}
                checked={selectedCenters.some((c) => c.id === center.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedCenters([...selectedCenters, center]);
                  } else {
                    setSelectedCenters(
                      selectedCenters.filter((c) => c.id !== center.id)
                    );
                  }
                }}
                className="custom-checkbox"
                style={{ transform: "scale(1.5)" }}
              />
              <label
                htmlFor={`center-${center.id}`}
                className="text-base cursor-pointer"
              >
                {center.name}
              </label>
            </div>
          ))}
        </div>

        {/* Botón de exportar */}
        <div className="flex justify-content-end mt-4">
          <Button
            label={isExporting ? "Exportando..." : "Descargar baremo(s)"}
            icon={isExporting ? "pi pi-spin pi-spinner" : "pi pi-file-excel"}
            severity="info"
            onClick={handleExport}
            disabled={selectedCenters.length === 0 || isExporting}
            className="px-4 py-2 text-base"
          />
        </div>
      </div>
    </Dialog>
  );
}